import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FetcherProviderPropertiesType } from "@website/fetcher/provider/provider.types";
import { FC } from "react";
const queryCache = new QueryCache();
export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30_000),
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      gcTime: 15 * 60 * 1000,
      // Garbage collect after 15 minutes
      placeholderData: keepPreviousData,
      staleTime: 15 * 60 * 1000 //stale for 15 minutes
    }
  }
});
export const FetcherProvider: FC<FetcherProviderPropertiesType> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};